import {CommonModule, CurrencyPipe, PercentPipe} from '@angular/common';
import {Component, Input} from '@angular/core';
import {RecipientStat} from '@gatewee/types/recipient-stat';
import {UtilsModule} from '@gatewee/utils';
import {TranslateModule} from '@ngx-translate/core';

export interface RecipientStatPaymentMethodRow {
  method: string;
  count: number;
  volume: number;
}

@Component({
  selector: 'gatewee-recipient-stat-overview',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    UtilsModule,
    CurrencyPipe,
    PercentPipe,
  ],
  templateUrl: './gatewee-recipient-stat-overview.component.html',
  styleUrls: ['./gatewee-recipient-stat-overview.component.css'],
})
export class GateweeRecipientStatOverviewComponent {
  @Input() stat: RecipientStat | null = null;

  get paymentMethodRows(): RecipientStatPaymentMethodRow[] {
    if (!this.stat) return [];

    const methods = new Set([
      ...Object.keys(this.stat.invoiceCountByMethod ?? {}),
      ...Object.keys(this.stat.invoiceVolumeByMethod ?? {}),
    ]);

    return [...methods]
      .map(method => ({
        method,
        count: this.stat?.invoiceCountByMethod?.[method] ?? 0,
        volume: this.stat?.invoiceVolumeByMethod?.[method] ?? 0,
      }))
      .filter(row => row.count > 0 || row.volume > 0)
      .sort((a, b) => b.volume - a.volume);
  }
}
